import { render, staticRenderFns } from "./BaseCertificate.vue?vue&type=template&id=f59e037e&scoped=true"
import script from "./BaseCertificate.vue?vue&type=script&lang=js"
export * from "./BaseCertificate.vue?vue&type=script&lang=js"
import style0 from "./BaseCertificate.vue?vue&type=style&index=0&id=f59e037e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f59e037e",
  null
  
)

export default component.exports